// extracted by mini-css-extract-plugin
module.exports = {"sectionEmpty":"SectionEmpty_sectionEmpty__3m4wW","sectionEmpty__iconWrapper":"SectionEmpty_sectionEmpty__iconWrapper__2Rop0"};